import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import './Profile.css';

const Profile = () => {
  const { user, logIn } = useContext(AuthContext);
  const [profile, setProfile] = useState({ firstName: '', lastName: '', email: '' });
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) {
      setProfile({ firstName: user.firstName, lastName: user.lastName, email: user.email });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile(prevProfile => ({
      ...prevProfile, [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    setStatus(null);

    fetch('/api/profile', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}` // Adjust if using token-based auth
      },
      body: JSON.stringify(profile)
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          logIn(data.user); // Update the user context with the new data
          setStatus({ type: 'success', message: 'Profile updated.' });
        } else {
          setStatus({ type: 'error', message: data.message || 'Error updating profile.' });
        }
      })
      .catch(error => {
        console.error('Error updating profile:', error);
        setStatus({ type: 'error', message: 'Error updating profile.' });
      })
      .finally(() => setSaving(false));
  };

  return (
    <main className="profile-page">
      <section className="profile-shell">
        <div className="profile-header">
          <p className="profile-eyebrow">Profile</p>
          <h1>Your information</h1>
          <p>Keep your name current so your saved uploads and account feel personal to you.</p>
        </div>

        <form className="profile-card" onSubmit={handleSubmit}>
          {status && (
            <div className={`profile-status profile-status-${status.type}`} role="status">
              {status.message}
            </div>
          )}
          <div className="profile-field-grid">
            <label>
              First name
              <input type="text" name="firstName" value={profile.firstName} onChange={handleChange} required />
            </label>
            <label>
              Last name
              <input type="text" name="lastName" value={profile.lastName} onChange={handleChange} required />
            </label>
          </div>
          <label>
            Email
            <input type="email" name="email" value={profile.email} onChange={handleChange} required disabled />
          </label>
          <p className="profile-help">Email changes are locked for now because they affect sign-in and account security.</p>
          <button type="submit" disabled={saving}>{saving ? 'Updating...' : 'Update profile'}</button>
        </form>
      </section>
    </main>
  );
};

export default Profile;
